import { MatTableService } from '@/shared/components/mat-table-base/mat-table.service';
import { Injectable, untracked } from '@angular/core';
import { getSubscriptionOverdraftColumns } from './subscription-overdraft.list.columns';
import {
  SubscriptionOverdraftTableHeaders,
  SubscriptionOverdraftTableRow,
} from './subscription-overdraft.list.types';

@Injectable()
export class SubscriptionOverdraftListTableService extends MatTableService<SubscriptionOverdraftTableRow> {
  private initialized = false;

  initialize(headers: SubscriptionOverdraftTableHeaders): void {
    if (this.initialized) {
      return;
    }

    this.setColumns(getSubscriptionOverdraftColumns(headers));
    this.setAppearance({
      dense: false,
      striped: true,
      bordered: true,
      heightMode: 'auto',
      fillContainer: true,
      showRowHover: false,
    });
    this.initialized = true;
  }

  /** Push static rows without fetch/refresh (avoids effect ↔ isLoading loops). */
  setRows(rows: SubscriptionOverdraftTableRow[]): void {
    if (!this.initialized) {
      return;
    }
    untracked(() => {
      this.data.set(rows);
      this.totalCount.set(rows.length);
      this.isLoading.set(false);
    });
  }
}
